import { MouseEvent, useState } from 'react';

export const useAnchorElement = () => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const isAnchorElementOpen = Boolean(anchorEl);

  const toggleAnchorElement = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl((prevAnchorEl) => (prevAnchorEl ? null : event.currentTarget));
  };

  const handleCloseAnchorElement = () => setAnchorEl(null);

  return {
    anchorEl,
    isAnchorElementOpen,
    toggleAnchorElement,
    handleCloseAnchorElement,
  };
};
